import { BuildingDTO } from "shared/types/building";
import { BuildingContactsTable } from "./buildingContactsTable";

interface BuildingContactsTabProps {
  building: BuildingDTO;
}

export const BuildingContactsTab = ({ building }: BuildingContactsTabProps) => {
  return (
    <BuildingContactsTable buildingId={building.id as string} />
  );
};

